// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as MapLabel$LumiFacilityMap from "./MapLabel.res.js";
import * as FacilityMap$LumiDocuments from "lumi-documents/lib/es6/src/FacilityMap.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";

function MapObject(props) {
  let scale = props.scale;
  let __fitLabel = props.fitLabel;
  let __objectStyle = props.objectStyle;
  let shape = props.shape;
  let objectTransform = props.objectTransform;
  let mapTransform = props.mapTransform;
  let objectStyle = __objectStyle !== undefined ? __objectStyle : ObjectStyle$LumiFacilityMap.empty;
  let fitLabel = __fitLabel !== undefined ? __fitLabel : false;
  let className = ObjectStyle$LumiFacilityMap.className(objectStyle);
  let style = objectStyle.style;
  return JsxRuntime.jsxs("g", {
    children: [
      JsxRuntime.jsx(FacilityMap$LumiDocuments.Shape.make, {
        shape: shape
      }),
      LumiReact.renderOption(undefined, objectStyle.label, label => {
        let outerTransform = Transform$Linear.M23f.compose(mapTransform, objectTransform);
        return JsxRuntime.jsx(MapLabel$LumiFacilityMap.make, {
          outerTransform: outerTransform,
          position: FacilityMap$LumiDocuments.Shape.center(shape),
          className: "label is-unselectable",
          style: objectStyle.labelStyle,
          fitInside: fitLabel ? shape : undefined,
          scale: scale,
          children: label
        });
      }),
      LumiReact.renderOption(undefined, objectStyle.title, title => JsxRuntime.jsx("title", {
        children: title
      }))
    ],
    className: className,
    style: style,
    onClick: props.onClick,
    transform: LumiSVG.Transform.Matrix.fromM23f_(objectTransform)
  });
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let make = MapObject;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  make,
}
/* LumiSVG Not a pure module */
